import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <mask
        id="a"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={1}
        width={22}
        height={22}
      >
        <path
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
          fill={props.color ?? "#fff"}
          stroke={props.color ?? "#fff"}
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M10 12V8.536l3 1.732L16 12l-3 1.732-3 1.732V12z"
          fill="#000"
          stroke="#000"
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#a)">
        <path d="M0 0h24v24H0V0z" fill={props.color ?? "#fff"} />
      </g>
    </svg>
  );
}

export default SvgComponent;
